export const FILTER_ACTIONS = {
  SET_YEAR: 'SET_YEAR',
  SET_POLICY_TYPE: 'SET_POLICY_TYPE',
  SET_SUB_TYPE: 'SET_SUB_TYPE',
  RESET_FILTERS: 'RESET_FILTERS',
  SET_SELECTED_INSURANCE: 'SET_SELECTED_INSURANCE',
  SET_CLEAR_STATE: 'SET_CLEAR_STATE',
}
